/**
 * Definición de tours — solo páginas incluidas aquí están en ALL_TOURS.
 */
export const TOUR_PAGE_DASHBOARD_KEY = 'tour_page_dashboard'

export const TOUR_PAGE_DASHBOARD = {
  id: 'dashboard-page',
  storageKey: TOUR_PAGE_DASHBOARD_KEY,
  version: 'v3',
  label: 'Dashboard',
  steps: [
    {
      targetId: 'tour-dashboard-refresh',
      title: '🔄 Actualizar',
      description: 'Refresca los datos del dashboard sin recargar la página.',
      position: 'bottom',
    },
    {
      targetId: 'tour-dashboard-stats',
      title: '📊 Tus números clave',
      description: 'Documentos firmados, pendientes por firmar y documentos que has enviado.',
      position: 'bottom',
    },
    {
      targetId: 'tour-dashboard-chart',
      title: '📈 Documentos por mes',
      description: 'Gráfico de actividad; cambia el rango con el selector de meses.',
      position: 'top',
    },
    {
      targetId: 'tour-dashboard-firmantes',
      title: '👥 Firmantes',
      description: 'Resumen de firmados y pendientes, lista y recordatorios.',
      position: 'top',
    },
    {
      targetId: 'tour-dashboard-top-firmantes',
      title: '🏆 Top firmantes',
      description: 'Ranking de firmantes más activos cuando hay datos.',
      position: 'top',
    },
    {
      targetId: 'tour-dashboard-firmas-recientes',
      title: '📄 Firmas recientes',
      description: 'Últimas firmas y descarga de PDF cuando corresponda.',
      position: 'top',
    },
    {
      targetId: 'tour-sidebar-nav',
      title: '🧭 Menú lateral',
      description: 'Navega por el sistema desde aquí (Dashboard, editor, historial, configuración, etc.).',
      position: 'right',
    },
    {
      targetId: 'tour-sidebar-perfil',
      title: '👤 Perfil y sesión',
      description: 'Tu nombre, correo, rol y cierre de sesión.',
      position: 'right',
    },
    {
      targetId: 'tour-dashboard-help',
      title: '❓ Ayuda',
      description: 'Vuelve a abrir el tour de esta página cuando lo necesites.',
      position: 'left',
    },
  ],
}

export const TOUR_PAGE_UPLOAD_KEY = 'tour_page_upload'

export const TOUR_PAGE_UPLOAD = {
  id: 'upload-page',
  storageKey: TOUR_PAGE_UPLOAD_KEY,
  version: 'v1',
  label: 'Subir documento',
  steps: [
    {
      targetId: 'tour-upload-button',
      title: '📤 Subir documento',
      description: 'Selecciona un archivo PDF para comenzar el proceso de firma.',
      position: 'bottom',
    },
    {
      targetId: 'tour-upload-help',
      title: '❓ Ayuda',
      description: 'Puedes volver a ver este recorrido cuando lo necesites.',
      position: 'left',
    },
  ],
}

export const TOUR_PAGE_EDITOR_KEY = 'tour_page_editor'

export const TOUR_PAGE_EDITOR = {
  id: 'editor-page',
  storageKey: TOUR_PAGE_EDITOR_KEY,
  version: 'v3',
  label: 'Editor de PDF',
  steps: [
    {
      targetId: 'tour-pdf-viewer',
      title: '📄 Vista del documento',
      description: 'Aquí puedes visualizar el documento que vas a firmar.',
      position: 'top',
    },
    {
      targetId: 'tour-pdf-navigation',
      title: '📑 Navegación de páginas',
      description: 'Usa estos controles para moverte entre páginas del documento.',
      position: 'bottom',
    },
    {
      targetId: 'tour-document-info',
      title: '📋 Información del documento',
      description:
        'Aquí puedes ver datos clave como el número total de páginas y la página actual.',
      position: 'left',
    },
    {
      targetId: 'tour-firmantes',
      title: '👥 Firmantes',
      description: 'Aquí agregas las personas que deben firmar el documento.',
      position: 'left',
    },
    {
      targetId: 'tour-orden-firmas',
      title: '🔁 Orden de firmas',
      description:
        'Activa esta opción si quieres que los firmantes firmen en un orden específico.',
      position: 'left',
    },
    {
      targetId: 'tour-invitar-firmante',
      title: '➕ Invitar firmante',
      description: 'Si el usuario no existe, puedes invitarlo manualmente.',
      position: 'left',
    },
    {
      targetId: 'tour-visualizadores',
      title: '👁️ Visualizadores',
      description: 'Usuarios que podrán ver el documento sin firmarlo.',
      position: 'left',
    },
    {
      targetId: 'tour-observaciones',
      title: '📝 Observaciones',
      description: 'Agrega comentarios o notas sobre el documento.',
      position: 'top',
    },
    {
      targetId: 'tour-editor-help',
      title: '❓ Ayuda',
      description: 'Puedes volver a ver este recorrido cuando lo necesites.',
      position: 'left',
    },
  ],
}

export const TOUR_PAGE_PENDING_KEY = 'tour_page_pending'

export const TOUR_PAGE_PENDING = {
  id: 'pending-page',
  storageKey: TOUR_PAGE_PENDING_KEY,
  version: 'v1',
  label: 'Mis Pendientes',
  steps: [
    {
      targetId: 'tour-pending-header',
      title: '📄 Mis pendientes',
      description: 'Aquí puedes ver los documentos que requieren tu firma.',
      position: 'bottom',
    },
    {
      targetId: 'tour-pending-refresh',
      title: '🔄 Actualizar',
      description: 'Presiona aquí para actualizar la lista de documentos pendientes.',
      position: 'left',
    },
    {
      targetId: 'tour-pending-empty',
      title: '📭 Sin pendientes',
      description: 'Cuando no tengas documentos por firmar, verás este mensaje.',
      position: 'top',
    },
    {
      targetId: 'tour-pending-help',
      title: '❓ Ayuda',
      description: 'Puedes volver a ver esta guía cuando lo necesites.',
      position: 'left',
    },
  ],
}

export const TOUR_PAGE_SIGNED_TRACKING_KEY = 'tour_page_signed_tracking'

export const TOUR_PAGE_SIGNED_TRACKING = {
  id: 'signed-tracking-page',
  storageKey: TOUR_PAGE_SIGNED_TRACKING_KEY,
  version: 'v1',
  label: 'Firmados y Pendientes',
  steps: [
    {
      targetId: 'tour-signed-header',
      title: '📂 Firmados y Pendientes',
      description:
        'Aquí puedes gestionar y consultar documentos enviados, recibidos y en seguimiento.',
      position: 'bottom',
    },
    {
      targetId: 'tour-signed-filters',
      title: '🔎 Filtros',
      description:
        'Usa estos filtros para buscar documentos por usuario o por rango de fechas.',
      position: 'bottom',
    },
    {
      targetId: 'tour-signed-tabs',
      title: '🗂️ Pestañas',
      description:
        'Aquí puedes alternar entre "Mis documentos" y "En seguimiento". Cada pestaña muestra información diferente.',
      position: 'bottom',
    },
    {
      targetId: 'tour-signed-tab-mis-documentos',
      title: '📄 Mis documentos',
      description:
        'Aquí ves los documentos enviados o recibidos, sus estados, porcentaje de firmas y acciones disponibles.',
      position: 'bottom',
    },
    {
      targetId: 'tour-signed-refresh',
      title: '🔄 Actualizar',
      description: 'Presiona aquí para refrescar la información de la lista.',
      position: 'left',
    },
    {
      targetId: 'tour-signed-document-list',
      title: '📋 Lista de documentos',
      description:
        'En esta sección ves cada documento, su estado, progreso de firmas y acciones como descargar o eliminar.',
      position: 'top',
    },
    {
      targetId: 'tour-signed-tab-seguimiento',
      title: '👁️ En seguimiento',
      description:
        'Aquí puedes monitorear documentos en proceso y revisar su avance en tiempo real.',
      position: 'bottom',
    },
    {
      targetId: 'tour-signed-help',
      title: '❓ Ayuda',
      description: 'Puedes volver a ver esta guía cuando lo necesites.',
      position: 'left',
    },
  ],
}

export const TOUR_PAGE_SIGNATURE_CONFIG_KEY = 'tour_page_signature_config'

export const TOUR_PAGE_SIGNATURE_CONFIG = {
  id: 'signature-config-page',
  storageKey: TOUR_PAGE_SIGNATURE_CONFIG_KEY,
  version: 'v1',
  label: 'Configuración de Firma',
  steps: [
    {
      targetId: 'tour-signature-config-header',
      title: '✍️ Configuración de Firma',
      description: 'Aquí puedes gestionar tus firmas personales.',
      position: 'bottom',
    },
    {
      targetId: 'tour-signature-list',
      title: '🗂️ Mis firmas',
      description: 'Aquí ves todas las firmas que tienes creadas.',
      position: 'top',
    },
    {
      targetId: 'tour-signature-default',
      title: '⭐ Firma predeterminada',
      description:
        'Puedes marcar una firma como predeterminada para usarla automáticamente al firmar.',
      position: 'top',
    },
    {
      targetId: 'tour-signature-delete',
      title: '🗑️ Eliminar firma',
      description: 'Aquí puedes eliminar una firma que ya no necesites.',
      position: 'left',
    },
    {
      targetId: 'tour-signature-add',
      title: '➕ Agregar firma',
      description: 'Usa este botón para crear una nueva firma.',
      position: 'top',
    },
    {
      targetId: 'tour-signature-note',
      title: 'ℹ️ Nota importante',
      description: 'Aquí se explica cómo funciona la firma predeterminada.',
      position: 'top',
    },
    {
      targetId: 'tour-signature-help',
      title: '❓ Ayuda',
      description: 'Puedes volver a ver esta guía cuando lo necesites.',
      position: 'left',
    },
  ],
}

export const TOUR_MODAL_SIGNATURE_CREATE_KEY = 'tour_modal_signature_create'

export const TOUR_MODAL_SIGNATURE_CREATE = {
  id: 'signature-create-modal',
  storageKey: TOUR_MODAL_SIGNATURE_CREATE_KEY,
  version: 'v2',
  label: 'Agregar Nueva Firma',
  /** Orden alineado al DOM: primero texto (campos), luego tipo imagen y subida. */
  steps: [
    {
      targetId: 'tour-signature-modal-header',
      title: '🆕 Agregar nueva firma',
      description: 'Aquí puedes crear una firma nueva.',
      position: 'bottom',
    },
    {
      targetId: 'tour-signature-type-selector',
      title: '🔀 Tipo de firma',
      description: 'Elige si quieres crear una firma con texto o con imagen.',
      position: 'bottom',
    },
    {
      targetId: 'tour-signature-type-text',
      title: '🔤 Firma con texto',
      description: 'Selecciona esta opción para crear una firma escrita con tipografía.',
      position: 'bottom',
    },
    {
      targetId: 'tour-signature-text-input',
      title: '⌨️ Texto de la firma',
      description: 'Aquí escribes el texto que aparecerá en tu firma.',
      position: 'top',
    },
    {
      targetId: 'tour-signature-fonts',
      title: '🔠 Tipo de letra',
      description: 'Aquí eliges el estilo visual de tu firma en texto.',
      position: 'top',
    },
    {
      targetId: 'tour-signature-type-image',
      title: '🖼️ Firma con imagen',
      description: 'Selecciona esta opción para subir una imagen de tu firma.',
      position: 'bottom',
    },
    {
      targetId: 'tour-signature-image-upload',
      title: '📤 Subir imagen',
      description: 'Aquí puedes cargar una imagen de tu firma.',
      position: 'top',
    },
    {
      targetId: 'tour-signature-save',
      title: '💾 Guardar firma',
      description: 'Presiona aquí para guardar la nueva firma.',
      position: 'left',
    },
    {
      targetId: 'tour-signature-cancel',
      title: '↩️ Cancelar',
      description: 'Usa este botón para salir sin guardar cambios.',
      position: 'left',
    },
  ],
}

export const ALL_TOURS = {
  'dashboard-page': TOUR_PAGE_DASHBOARD,
  'upload-page': TOUR_PAGE_UPLOAD,
  'editor-page': TOUR_PAGE_EDITOR,
  'pending-page': TOUR_PAGE_PENDING,
  'signed-tracking-page': TOUR_PAGE_SIGNED_TRACKING,
  'signature-config-page': TOUR_PAGE_SIGNATURE_CONFIG,
  'signature-create-modal': TOUR_MODAL_SIGNATURE_CREATE,
}

export const TOUR_DOM_READY_DELAY_MS = 400

export function shouldShowTour(tour) {
  if (!tour?.storageKey) return true
  const ver = String(tour.version ?? 'v1')
  return localStorage.getItem(tour.storageKey) !== ver
}

/**
 * Elimina del localStorage todo el progreso de tours (claves con prefijo `tour_`).
 * Genérico: cubre tours presentes y futuros sin depender de ALL_TOURS.
 */
export function resetAllTours() {
  try {
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('tour_')) {
        localStorage.removeItem(key)
      }
    })
  } catch {
    /* ignore */
  }
}

/** Alias de resetAllTours (misma semántica). */
export function clearAllToursSeenFromStorage() {
  resetAllTours()
}
